import script from "./Drop.vue?vue&type=script&setup=true&lang=js"
export * from "./Drop.vue?vue&type=script&setup=true&lang=js"

import "./Drop.vue?vue&type=style&index=0&id=cdb33666&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb33666"]])

export default __exports__